<mat-chip-listbox>
  <mat-chip-option
    *ngFor="let chip of filterChips"
    (removed)="chip.onRemove(chip.value)"
    [title]="chip.label"
  >
    {{ chip.label }}
    <mat-icon *ngIf="chip.onRemove" matChipRemove>clear</mat-icon>
  </mat-chip-option>
</mat-chip-listbox>
